import { Fragment } from 'react';

import useGroupRegistrationAdd from './UseGroupRegistrationAdd';

import GroupRegistrationForm from '../../components/forms/GroupRegistrationForm';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GroupRegistrationAdd = () => {
  const {
    isLoading,
    isSaving,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onBackClicked,
    groupTypeName,
    GROUP_ROLES_ROLE_GROUP_ID
  } = useGroupRegistrationAdd();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Add {groupTypeName} Group</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <GroupRegistrationForm
          formState={formState}
          errorState={errorState}
          onFormValueChanged={onFormValueChanged}
          roleGroupId={GROUP_ROLES_ROLE_GROUP_ID} />
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">Create Group</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
            {errorState && errorState.errorOnSubmitAction
              && <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction}</p>
            }
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default GroupRegistrationAdd;